'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _lodash = require('lodash.pick');

var _lodash2 = _interopRequireDefault(_lodash);

var _currencies = require('../../helpers/currencies');

var _currencies2 = _interopRequireDefault(_currencies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencyDropdown = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CurrencyDropdown, _Component);

  function CurrencyDropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CurrencyDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CurrencyDropdown.__proto__ || (0, _getPrototypeOf2.default)(CurrencyDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currency: _this.props.currency,
      currencyLabel: _currencies2.default[_this.props.currency] + ' (' + _this.props.currency + ')'
    }, _this.topCurrencies = (0, _lodash2.default)(_currencies2.default, ['CAD', 'USD', 'EUR']), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CurrencyDropdown, [{
    key: 'handleChangeCurrency',
    value: function handleChangeCurrency(currency, event) {
      var _this2 = this;

      event.preventDefault();

      this.setState({
        currency: currency,
        currencyLabel: _currencies2.default[currency] + ' (' + currency + ')'
      }, function () {
        _this2.props.onChange(currency);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          currencyLabel = _state.currencyLabel,
          currency = _state.currency;


      return _react2.default.createElement(
        _reactBootstrap.DropdownButton,
        {
          id: 'currenciesDropdown',
          bsStyle: 'link',
          dropup: true,
          title: currencyLabel,
          className: 'currency-dropdown',
          onSelect: this.handleChangeCurrency.bind(this)
        },
        (0, _keys2.default)(this.topCurrencies).map(function (curCode) {
          return _react2.default.createElement(
            _reactBootstrap.MenuItem,
            {
              key: 'topCurrencies-' + curCode,
              eventKey: curCode,
              className: currency === curCode ? 'active' : ''
            },
            _this3.topCurrencies[curCode],
            ' ',
            '(',
            curCode,
            ')'
          );
        }),
        _react2.default.createElement(_reactBootstrap.MenuItem, { divider: true })
      );
    }
  }]);
  return CurrencyDropdown;
}(_react.Component), _class.propTypes = {
  onChange: _propTypes2.default.func,
  currency: _propTypes2.default.oneOf((0, _keys2.default)(_currencies2.default)),
  polyglot: _propTypes2.default.object.isRequired

}, _temp2);
exports.default = CurrencyDropdown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/CurrencyDropdown.js
// module id = 2204
// module chunks = 0